




























































































import ChartJS from "chart.js";
import Treemap from "./Treemap.vue";
import { Vue, Component, Prop, Watch, Lifecycle, p } from "av-ts";

@Component({
    components: {
        Treemap
    }
})
export default class ChartWrapper extends Vue {
    @Prop type = p<string>({
        required: true
    });

    @Prop data = p<Chart.ChartData>({
        required: true
    });

    @Prop options = p<Chart.ChartOptions>({
        default: () => {
            return {};
        }
    });

    chart: Chart | null = null;

    mountChart() {
        if (this.type !== "bar" && this.type !== "radar" && this.type !== "line") {
            this.chart = {
                destroy: () => { },
                update: () => { }
            } as Chart;
        } else {
            const chartOptions: Chart.ChartOptions = Object.assign({
                maintainAspectRatio: false,
                responsive: true,
                layout: {
                    padding: {
                        bottom: 10
                    }
                }
            }, this.options);
            if (this.type === "bar") {
                if (chartOptions.legend === undefined) {
                    chartOptions.legend = {};
                }
                if (this.data && this.data.datasets) {
                    let minVal = Math.min(
                        Math.min.apply(this, (<Number[]> this.data.datasets[0].data).filter(Boolean)),
                        Math.min.apply(this, (<Number[]> this.data.datasets[1].data).filter(Boolean)));
                    let maxVal = Math.max(
                        Math.max.apply(this, (<Number[]> this.data.datasets[0].data).filter(Boolean)),
                        Math.max.apply(this, (<Number[]> this.data.datasets[1].data).filter(Boolean)));
                    chartOptions.scales = {
                        yAxes: [{
                            ticks: {
                                min: (Math.round((minVal - 200) / 100)) * 100,
                                max: (Math.round((maxVal + 100) / 100)) * 100,
                                stepSize: 100
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                autoSkip: false
                            }
                        }]
                    };
                }
                chartOptions.legend.display = false;
            } else if (this.type == "radar") {
                if (this.data && this.data.datasets) {
                    let axisMax = 100;
                    let steps = 20;
                    let maxVal = Math.max(
                        Math.max.apply(this, (<Number[]> this.data.datasets[0].data).filter(Boolean)),
                        Math.max.apply(this, (<Number[]> this.data.datasets[1].data).filter(Boolean)));
                    if (maxVal > 100) {
                        axisMax = (Math.round((maxVal + 100) / 100)) * 100;
                        steps = 100;
                    }
                    chartOptions.scale = {
                        ticks: {
                            display: false,
                            min: 0,
                            max: axisMax,
                            stepSize: steps
                        }
                    };
                }
            } else if (this.type == "line") {
                if (this.data && this.data.datasets) {
                    let minVal = 10000;
                    let maxVal = 0;
                    for (let i=0; i < this.data.datasets.length; i++) {
                        minVal = Math.min(minVal,
                        Math.min.apply(this, (<Number[]> this.data.datasets[i].data).filter(Boolean)));
                        maxVal = Math.max(maxVal,
                        Math.max.apply(this, (<Number[]> this.data.datasets[i].data).filter(Boolean)));
                    }
                    chartOptions.scales = {
                        yAxes: [{
                            ticks: {
                                min: (Math.round((minVal - 100) / 100)) * 100,
                                max: (Math.round((maxVal + 100) / 100)) * 100,
                                stepSize: 100
                            }
                        }]
                    };
                }
            }

            const canvas = this.$el.querySelector("canvas")!;
            const config = {
                type: this.type,
                data: this.data,
                options: chartOptions
            };
            this.chart = new ChartJS(canvas.getContext("2d")!, config);
            this.chart.resize();
        }
    }

    @Lifecycle
    mounted() {
        this.mountChart();
    }

    resetChart() {
        window.dispatchEvent(new Event("resize"));
        this.$nextTick(() => {
            this.chart!.destroy();
            this.mountChart();
        });
    }

    @Lifecycle
    beforeUpdate() {
        if (this.type == "topicDependency") {
            this.chart!.destroy();
        }
    }

    @Watch("type")
    handleTypeChange(_newType: string, _oldType: string) {
        if (this.type == "topicDependency") {
            this.chart!.destroy();
            this.$nextTick(() => {
                this.mountChart();
            });
        } else {
            this.resetChart();
        }
    }

    @Watch("data")
    handleDataChange(_newData: Chart.ChartData, _oldData: Chart.ChartData) {
        this.resetChart();
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/charts/Chart.vue